import React, { useEffect } from 'react';

const GOOGLE_MAPS_API_KEY = 'AIzaSyDXcuNu9hM04ec2v4lqzrfcrmIKjILZMRU';

function loadScript(src, position, id) {
  if (!position) return;
  if (document.getElementById(id)) return;

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

const GoogleMapsLoader = ({ children }) => {
  useEffect(() => {
    if (!document.querySelector('#google-maps')) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`,
        document.querySelector('head'),
        'google-maps'
      );
    }
  }, []);

  return <>{children}</>;
};

export default GoogleMapsLoader;
